import { acosColor, fmtPct, COLORS } from "@/lib/format";

// Confidence — square Plex Mono tag. HIGH = solid green, MED = warn, LOW = neutral outline.
const CONF = {
  high: "ss-tag ss-tag--good",
  medium: "ss-tag ss-tag--warn",
  low: "ss-tag ss-tag--muted",
};

export const ConfidencePill = ({ level }) => (
  <span className={CONF[level] || CONF.low} data-testid={`confidence-pill-${level}`}>
    {level}
  </span>
);

// ACoS % pill — same square tag, color-coded by band.
export const AcosPill = ({ value, dp = 1 }) => {
  if (value == null) return <span className="ss-tag ss-tag--muted">—</span>;
  const c = acosColor(value);
  const cls =
    c === COLORS.good ? "ss-tag ss-tag--good" : c === COLORS.warn ? "ss-tag ss-tag--warn" : "ss-tag ss-tag--bad";
  return <span className={cls}>{fmtPct(value, dp)}</span>;
};
